import { useEffect, useState } from 'react';
import { subscribeDisplay, type DisplayMessage } from '../lib/display';
import styles from './PlayerDisplayPage.module.css';

/**
 * The player-facing display window. Subscribes to the GM's broadcast channel and shows
 * the pushed image fullscreen, or an idle candle screen when cleared.
 */
export function PlayerDisplayPage() {
  const [msg, setMsg] = useState<DisplayMessage | null>(null);

  useEffect(() => {
    document.title = 'GM Binder · Display Giocatori';
    const unsub = subscribeDisplay((m) => setMsg(m), { replayLast: true });
    return unsub;
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key.toLowerCase() === 'f') {
        if (document.fullscreenElement) void document.exitFullscreen();
        else void document.documentElement.requestFullscreen().catch(() => undefined);
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  const showImage = msg && msg.type !== 'clear' && msg.payload?.src;

  return (
    <div className={styles.screen}>
      {showImage ? (
        <figure className={styles.figure}>
          <img
            className={styles.img}
            src={msg!.payload.src}
            alt={msg!.payload.title ?? ''}
            style={{ objectFit: msg!.payload.fit === 'cover' ? 'cover' : 'contain' }}
          />
          {(msg!.payload.title || msg!.payload.caption) && (
            <figcaption className={styles.caption}>
              {msg!.payload.title && <strong>{msg!.payload.title}</strong>}
              {msg!.payload.caption && <span>{msg!.payload.caption}</span>}
            </figcaption>
          )}
        </figure>
      ) : (
        <div className={styles.idle}>
          <div className={styles.flame} aria-hidden>
            🕯️
          </div>
          <p className={styles.hint}>In attesa del Game Master…</p>
          <p className={styles.fs}>Premi F per schermo intero</p>
        </div>
      )}
    </div>
  );
}
